import React from "react";
import { newOnboardingSteps } from "../../locales/en";
import HeaderDashboard from "../../components/layout/header/HeaderDashboard";
import LoginAsUser from "../../components/loginasuser/LoginAsUser";
import Steps from "./steps";
import "./../../assets/scss/onboarding.scss";
import {
  INFO_EMAIL,
  MAILTO_INFO_EMAIL
} from "../../utils/constants/appConstants";
import { Link } from "react-router-dom";

const Onboarding = () => {
  return (
    <>
      <HeaderDashboard />
      <LoginAsUser />
      <div className="onboarding-wrap mb-3 mt-2">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="onboarding-wrap-container">
                <div className="onboard-title">
                  <h1>{newOnboardingSteps?.onBoardPageTitle}</h1>
                  <p>{newOnboardingSteps?.onBoardPageContent}</p>
                </div>
                <div className="onboarding-steps mt-4 pb-2">
                  <div className="label-title">
                    <h3>{newOnboardingSteps?.requiredTitle}</h3>
                  </div>

                  <Steps />
                </div>
                <div className="onboarding-footer mt-5 pt-3 pb-5">
                  <p>
                    {`${newOnboardingSteps?.footerText} `}
                    <Link to={MAILTO_INFO_EMAIL}>{INFO_EMAIL}</Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Onboarding;
